var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useDocumentsSection } from "@/components/Sections/Documents";
import { IS_SERVER } from "@/constants";
export const useDocuments = () => {
    const documents = useDocumentsSection();
    if (!documents)
        return null;
    const { files, display } = documents;
    if (!display)
        return null;
    const onPress = (url) => () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (IS_SERVER)
            return;
        (_a = window.open(url, "_blank")) === null || _a === void 0 ? void 0 : _a.focus();
    });
    return { onPress, files, display };
};
